import React, {useState} from 'react';
import {useNavigate, useParams} from "react-router";
import {getEventInfoApi} from "../../../../api/AdminApi";
import Loading from "../../../../components/Site/Loading/Loading";
import {useQueryClient} from "react-query";
import "react-multi-date-picker/styles/layouts/mobile.css"
import {useDebounceEffect} from "../../../../hoc/useDebounceEffect";
import Event from "../../../../components/Admin/event/Event";


const Details = () => {
    const {itemId} = useParams();
    const [eventData, setEventData] = useState({})
    const navigate = useNavigate();
    const client = useQueryClient();

    const invalidateData = async () => {
        await client.invalidateQueries('event_List')
    }

    const fetchData = async () => {
        try {
            const res = await getEventInfoApi(itemId)
            setEventData(res?.data?.data)
        } catch (e) {
            // log errors
        }

    }

    useDebounceEffect(async () => {
        if (itemId)
            await fetchData();
    }, 50, [])


    const callbackFun = async () => {
        await invalidateData();
        navigate(-1);
    }


    if (itemId > 0 && !eventData?.id) return <Loading/>
    return (
        <Event item={eventData} callbackFun={callbackFun}/>
    );
};

export default Details;